import React from 'react';

export default function ExpandArrowIcon(): JSX.Element {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.70711 1.63603H14.364M14.364 1.63603V7.29288M14.364 1.63603L1.63604 14.3639" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}